export default {
  feedback: {
    token_required: 'Klik på afkrydsningsfeltet for at bekræfte, at du er et menneske',
    frequent_requests:
      "Tjek dine SMS'er. Vi har allerede sendt koden til det angivne nummer via SMS. Hvis ikke, så tjek telefonnummeret, eller prøv igen om 10 minutter.",
  },
};
